import { gql } from "@apollo/client";

export const LIST_CATEGORIES_BY_PRIORITY = gql`
  {
    listCategoriesByPriority {
      id
      name
      type
      assetCategoryClass {
        id
        name
      }
    }
  }
`;

export const GET_ASSETS_BY_CATEGORY_ID = gql`
  query getAssetListByCategoryId(
    $assetClassId: String
    $categoryId: String!
    $maxPrice: Float
    $minPrice: Float
    $makeId: String
    $subCategoryId: String
    $locationIds: String
  ) {
    getAssetListByCategoryId(
      assetClassId: $assetClassId
      categoryId: $categoryId
      maxPrice: $maxPrice
      minPrice: $minPrice
      makeId: $makeId
      subCategoryId: $subCategoryId
      locationIds: $locationIds
    ) {
      id
      enNumber
      category {
        name
      }
      assignee {
        displayName
        profile_pic
        phoneno
        email
      }
      location {
        name
      }
      description
      manufactured
      hour
      make {
        id
        name
      }
      model {
        id
        name
      }
      assetMedias {
        id
        media
        isPublish
        isPrimary
        featuredMediaFlag
      }
      assetCategoryClass {
        id
        name
      }
    }
  }
`;
export const LIST_FEATURED_ASSET = gql`
  {
    getFeatureListingOfAsset {
      id
      enNumber
      assignee {
        id
        displayName
      }
      minPrice
      isDeleted
      sellingPrice
      make {
        id
        name
      }
      model {
        id
        name
      }

      assetMedias {
        id
        media
        isPrimary
        isPublish
        featuredMediaFlag
      }
      seller {
        id
        displayName
      }
      category {
        id
        name
        type
      }
      subCategory {
        id
        name
        type
      }
      assetCategoryClass {
        id
        name
      }
    }
  }
`;

export const GET_ALL_NOTIFICATIONS = gql`
  {
    getAllNotifications {
      id
      description
      url
      isRead
    }
  }
`;

export const GET_NEGOTIAITION_BY_ID = gql`
  query getAllNegotionaById($userId: String!) {
    getAllNegotiationsByBuyerId(userId: $userId) {
      id
      asset {
        id
      }
    }
  }
`;
